import { BaseGraphicsProvider } from "elements/base/graphics";
import { ResizeType } from "elements/base/types";
import type { ChartElement } from "elements/chart/schema";

export default class ChartGraphicsProvider extends BaseGraphicsProvider<ChartElement> {
  getResizeType(): ResizeType {
    return ResizeType.All;
  }
}
